import pyFormButton from 'pylon-vue/src/components/button/button';

const sButton = {
    name: 'sButton',
    extends: pyFormButton,
    props: {
        autocomplete: {
            default: "off"
        }
    }
}

export default sButton